import { CalendarDays, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const montazItems = [
  {
    path: '/montaz/planowanie',
    label: 'Planowanie i rozliczanie',
    icon: CalendarDays,
    description: 'Kalendarz montaży, lista zleceń, pracownicy, ekipy i rozliczenia',
    requiresPermission: 'installation:view',
  },
];

const Montaz = () => {
  const { hasPermission, isAdmin } = useAuth();

  const filteredItems = montazItems.filter((item) => {
    if (item.requiresPermission) {
      return hasPermission(item.requiresPermission) || isAdmin();
    }
    return true;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="module-page-title"><Wrench aria-hidden="true" /> Montaż</h2>
        <p>Planowanie i rozliczanie montaży</p>
      </div>

      <div className="page-content">
        <div className="tiles-grid">
          {filteredItems.map((item) => {
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className="tile-card module-tile">
              <span className="tile-icon module-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
              <h3 className="tile-title">{item.label}</h3>
              <p className="tile-description">{item.description}</p>
            </Link>;
          })}
        </div>
      </div>
    </div>
  );
};

export default Montaz;
